import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class FixitComponent {
    constructor() {
        this.componentSelector = "#fixit-mappings";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;

        $('.js-download-fixit-excel').off().on('click', function () {
            instance.download(instance);
        });

        $('#js-edit-fixit-mapping').off().on('click', function () {
            instance.editFixitMapping(instance);
        });
    }

    download(instance) {
        var uri = "/report/GetFixitAsExcel";

        var date = new Date();
        var cache = date.getUTCFullYear() + date.getUTCMonth() + date.getUTCDate() + date.getUTCHours() + date.getUTCMinutes() + date.getUTCSeconds() + date.getUTCMilliseconds();
        var fileName = "Fixit-mappings-" + date.toISOString().split('T')[0] + ".xlsx";

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };

        x.send();

        if (typeof (callback) === 'function')
            callback();
    }

    editFixitMapping(instance) {
        let customerNumber = $('.fixit-mapping-form #customernumber').val();
        let fixitId = $('.fixit-mapping-form #fixit-id').val();

        $('#success').hide();
        $('#error').hide();
        $('#empty-customernumber-error').hide();

        if (customerNumber == null || customerNumber == "") {
            $('#empty-customernumber-error').show();
        }
        else {
            axios({
                method: 'post',
                url: "/customer/editfixitmapping",
                data: { customerNumber: customerNumber, fixitId: fixitId }
            }).then(function (response) {
                if (response.data == "False") {
                    $('#error').show();
                }
                else {
                    $('#success').show();
                }
            }).catch(function (response) {
                console.log(response);
            });
        }

    }
}